import {
  ArticleOverviewPageStoryblok,
  ArticlePageStoryblok,
  ClinicOverviewPageStoryblok,
  ClinicPageStoryblok,
  ContentPageStoryblok,
  CooperationPartnersTypePageStoryblok,
  FactAdviceOverviewPageStoryblok,
  FactAdvicePageStoryblok,
  ListingPageStoryblok,
  PageStoryblok,
  PatientfeesPageStoryblok,
  PressreleasePageStoryblok,
  ServiceTypePageStoryblok,
  VaccinationBusLocationPageStoryblok,
  VaccinationBusOverviewPageStoryblok,
  VaccinationClinicPageStoryblok,
  VaccineTypePageStoryblok
} from "@/types/component-types"
import { ISbStoryData } from "storyblok-js-client"
import { create } from "zustand"

export type StoryblokPageTemplates = ISbStoryData<
  | PageStoryblok
  | ClinicPageStoryblok
  | ClinicOverviewPageStoryblok
  | FactAdvicePageStoryblok
  | ArticlePageStoryblok
  | ArticleOverviewPageStoryblok
  | ContentPageStoryblok
  | FactAdviceOverviewPageStoryblok
  | ListingPageStoryblok
  | PatientfeesPageStoryblok
  | PressreleasePageStoryblok
  | VaccinationBusLocationPageStoryblok
  | VaccinationBusOverviewPageStoryblok
  | VaccineTypePageStoryblok
  | VaccinationClinicPageStoryblok
  | ServiceTypePageStoryblok
  | CooperationPartnersTypePageStoryblok
>

export type StoryStoreProps = {
  story: StoryblokPageTemplates | undefined
}

export const useStoryStore = create<StoryStoreProps>(() => ({
  story: undefined
}))
